import { Module } from 'vuex'
import { RootState } from '@/store/store-types'
import { useTrainingProgramExecutionHttp } from '@/core/api/training-program-executions'
import { TrainingProgramExecution, TrainingProgramExecutionPayload } from '@/core/models/training-program-execution'

const state: TrainingProgramExecution = new TrainingProgramExecution(<TrainingProgramExecutionPayload>{})

export const programExecution: Module<TrainingProgramExecution, RootState> = {
    namespaced: true,
    state,
    mutations: {
        update: (state: TrainingProgramExecution, payload: TrainingProgramExecutionPayload) => {
            state.fill(payload)
        }
    },
    actions: {
        getOrNew: <T>(context: any, payload: { id: number | undefined, payload: any }): Promise<T> => {
            state.unset()
            if (payload.id) {
                return context.dispatch('get', payload)
            } else {
                return new Promise<T>((resolve) => {
                    resolve({} as T)
                })
            }
        },
        get: <T>(context: any, payload: { id: number, payload: any }): Promise<T> => {
            state.unset()
            return new Promise<T>((resolve, reject) => {
                useTrainingProgramExecutionHttp()
                    .find(payload.id, payload.payload)
                    .then((data: any) => {
                        context.commit('update', data.data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
        delete: <T>(context: any, payload: { id: number, force: boolean }): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useTrainingProgramExecutionHttp()
                    .del(payload.id)
                    .then((data: any) => {
                        context.commit('update', new TrainingProgramExecution(<TrainingProgramExecutionPayload>{}))
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
    },
    getters: {
        get: (state: TrainingProgramExecution): TrainingProgramExecution => {
            return state
        }
    }
}